export default "__VITE_ASSET__DX963pz$__"